import _ from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {isIntegrationTypeEnabled} from '../../../helpers/integrationTypesHelpers';
import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {getIntegrationsByType} from '../../../store/data/dataSelectors';
import {
  getAlphabeticalSortedIntegrationTypes,
  getIsIntegrationTypesLoading,
} from '../../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsAppsEnabledPage} from './settingsAppsEnabledPage';

/*
 * Selectors.
 */

export const getEnabledIntegrationTypes = createSelector(
  [getAlphabeticalSortedIntegrationTypes, getIntegrationsByType],
  (integrationTypes, integrations) =>
    _(integrationTypes)
      .filter((integrationType) => {
        // If the integration type itself is enabled, return early.
        if (isIntegrationTypeEnabled(integrationType)) {
          return true;
        }

        const integration = integrations[integrationType.id];
        return integration && integration.isEnabled;
      })
      .value(),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  integrationTypes: getEnabledIntegrationTypes,
  isIntegrationTypesLoading: getIsIntegrationTypesLoading,
}));

export const SettingsAppsEnabledPageContainer = connect(mapStateToProps)(SettingsAppsEnabledPage);
